import { useEffect, useState } from "react";

const usePaginatedArray = (array, options = {}) => {
  const perPage = options.perPage || 25;

  const fetchPage = (page) => {
    const newArray = [...array];
    const startIndex = perPage * (page - 1);
    return newArray.splice(startIndex, perPage);
  };

  const [page, setPage] = useState(options.page || 1);
  const [data, setData] = useState(fetchPage(page));

  useEffect(() => {
    setData(fetchPage(page));
  }, [page, array]);

  const totalPages = Math.max(Math.ceil(array.length / perPage), 1);

  return { page, data, totalPages, setPage };
};

export default usePaginatedArray;
